import { t } from '../../../common/i18n.js'
import type { Language } from '../../../common/types/i18n.js'
import { Eye } from '../icon/solar-icons.js'

export interface PortalImpersonationBannerProps {
    lang: Language
    /** Name of the user currently being viewed as. */
    viewingAsName: string
    isExiting: boolean
    onExit: () => void
}

/**
 * Full-width warning strip pinned above the app chrome while "View as" is
 * active. Purely presentational — the exit flow is owned by the app shell.
 */
export const PortalImpersonationBanner = ({
    lang,
    viewingAsName,
    isExiting,
    onExit,
}: PortalImpersonationBannerProps) => (
    <div className="portal-impersonation-banner" role="alert">
        <span className="portal-impersonation-banner__text">
            <Eye size={16} className="portal-impersonation-banner__icon" />
            {t.portal.viewAs.bannerViewingAs(viewingAsName)(lang)}
        </span>
        <button
            type="button"
            className="portal-impersonation-banner__exit"
            disabled={isExiting}
            onClick={onExit}
        >
            {t.portal.viewAs.bannerExit(lang)}
        </button>
    </div>
)
